import React from "react";
import { Box, Typography } from "@mui/material";
import Header from "../../components/Header";
import Button from "@mui/material/Button";

import axios from "axios";
import { useState, useEffect } from "react";

import swal from "sweetalert";
import { useLocation, useNavigate } from "react-router-dom";

function CircleForm() {
  const navigate = useNavigate();
  const location = useLocation();

  const fileConfiguarationDetail = location.state;

  const [alert, setAlert] = useState({ permission: false });

  const [spaces, setSpaces] = useState();

  const [formValues, setFormValues] = useState({
    spaceName: "",
    spaceId: "",
  });
  const [tokenGatingInfo, setTokenGatingInfo] = useState([
    {
      blockchainNetwork: "",
      tokenStandard: "",
      contractAddress: "",
      tokenId: "",
      nftRequired: "",
      tokenGatingType: "",
    },
  ]);

  const [edit, setEdit] = useState(false);

  function editForm() {
    if (fileConfiguarationDetail) {
      setFormValues({
        spaceId: fileConfiguarationDetail.spaceId,
        spaceName: fileConfiguarationDetail.spaceName,
      });
      setTokenGatingInfo(fileConfiguarationDetail.tokenGatingDetails);
      setEdit(true);
    }
  }

  function handleFormValue(e) {
    var { value } = e.target;
    const space = spaces.find((space) => space.id === Number(value));
    setFormValues({
      spaceId: space.id,
      spaceName: space.name,
    });
  }

  function handleTokenGatingInfo(i, e) {
    var { name, value } = e.target;
    let newTokenGatingInfo = [...tokenGatingInfo];

    if (name === "tokenGatingType") {
      if (value === "tokenId") {
        newTokenGatingInfo[i]["nftRequired"] = "";
      } else {
        newTokenGatingInfo[i]["tokenId"] = "";
      }
    }
    newTokenGatingInfo[i][name] = value;
    setTokenGatingInfo(newTokenGatingInfo);
  }

  function handleAddClick() {
    setTokenGatingInfo([
      ...tokenGatingInfo,
      {
        blockchainNetwork: "",
        tokenStandard: "",

        contractAddress: "",
        tokenId: "",
        nftRequired: "",
      },
    ]);
  }

  function removeFields(i, e) {
    let newTokenGatingInfo = [...tokenGatingInfo];
    newTokenGatingInfo.splice(i, 1);
    setTokenGatingInfo(newTokenGatingInfo);
  }

  function clearFirstField() {
    setTokenGatingInfo([
      {
        blockchainNetwork: "",
        tokenStandard: "",

        contractAddress: "",
        tokenId: "",
        nftRequired: "",
      },
    ]);
  }

  function handleRefresh() {
    swal(
      "Are you sure!",
      "Configurations you made will not be saved.",
      "warning",
      {
        buttons: ["Cancel", "OK"],
      }
    ).then((value) => {
      if (value) {
        setFormValues({
          spaceId: "",
          spaceName: "",
        });
        setTokenGatingInfo([
          {
            blockchainNetwork: "",
            tokenStandard: "",
            contractAddress: "",
            tokenId: "",
            nftRequired: "",
          },
        ]);
      }
    });
  }
  async function submitForm(event) {
    event.preventDefault();
    await axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/circle/token-gating-configuration-info`,
        {
          tokenGatingInfo,
          formValues,
        },
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        if (response.data.status === true) {
          swal({
            title: "Success!",
            text: response.data.message,
            icon: "success",
            button: "OK",
          }).then(() => {
            navigate("/token-gating/circle");
          });
        } else if (response.data.status === false) {
          swal({
            title: response.data.message,
            icon: "warning",
            button: "OK",
          });
        }
      })
      .catch((err) => {
        swal({
          title: "Something Went Wrong!",
          icon: "error",
          button: "OK",
        });
      });
  }

  async function editSubmitForm(e) {
    e.preventDefault();

    await axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/circle/token-gating-configuration`,
        {
          tokenGatingInfo,
          formValues,
        },
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        if (response.data.status === true) {
          swal(
            "Edited!",
            `Your token gating configuration for Space: ${formValues.spaceName} is Edited.`,
            "success",
            {
              button: "OK",
            }
          ).then(() => {
            navigate("/token-gating/circle");
          });
        } else {
          swal("Something went wrong!", ``, "error", {
            button: "OK",
          });
        }
      })
      .catch((err) => {
        swal({
          text: err.response.data.errorMessage,
          icon: "error",
        });
      });
  }

  function handleShow() {
    setAlert({ permission: false });
  }

  async function circleSpaces() {
    await axios
      .get(`${process.env.REACT_APP_BASE_URL}/circle/spaces`, {
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
        },
      })
      .then((response) => {
        setSpaces(response.data.spaces);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    circleSpaces();

    editForm();
  }, []);

  return (
    <Box m="20px">
      <Box
        variant="gradient"
        borderRadius="lg"
        shadow="lg"
        opacity={1}
        p={3}
        textAlign="left"
        sx={{
          bgcolor: "white",
          boxShadow: 4,
        }}
      >
        <Header title="Configure" />
        <form
          onSubmit={edit ? editSubmitForm : submitForm}
          style={{ width: "90%" }}
        >
          <Typography
            className="google-drive-typography-text"
            mb={"16px"}
            fontSize="15px"
          >
            Please provide space you want to give your user's as well as NFT
            token gating details for user's to get access to the space.
          </Typography>

          {tokenGatingInfo.map((element, index) => (
            <div className="form-container" key={index}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "115%",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      gap: "2%",
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <fieldset
                      disabled={edit}
                      className="login-form input-fullwidth"
                      style={{ cursor: edit && "not-allowed" }}
                    >
                      <label
                        htmlFor="space"
                        id="spaceLabel"
                        className="login-form-label"
                        style={{ cursor: edit && "not-allowed" }}
                      >
                        Select Space
                        <div className="input-div-css-1 input-div-css-2 input-fullwidth">
                          <div className="input-div-css-3">
                            <select
                              style={{ cursor: edit && "not-allowed" }}
                              required
                              className="input-custom-css select-input"
                              id="space"
                              aria-labelledby="spaceLabel"
                              name="space"
                              onChange={(e) => handleFormValue(e)}
                              value={formValues.spaceId}
                              aria-invalid="false"
                              defaultValue={""}
                            >
                              <option disabled value="">
                                Select Space
                              </option>
                              {spaces &&
                                spaces.map((space) => (
                                  <option key={space.id} value={space.id}>
                                    {space.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </label>
                    </fieldset>

                    <fieldset className="login-form input-fullwidth">
                      <label
                        htmlFor="blockchainNetwork"
                        id="blockchainNetworkLabel"
                        className="login-form-label"
                      >
                        Select BlockChain Network
                        <div className="input-div-css-1 input-div-css-2 input-fullwidth">
                          <div className="input-div-css-3">
                            <select
                              required
                              className="input-custom-css select-input"
                              id="blockchainNetwork"
                              aria-labelledby="blockchainNetworkLabel"
                              name="blockchainNetwork"
                              onChange={(e) => handleTokenGatingInfo(index, e)}
                              value={element.blockchainNetwork}
                              aria-invalid="false"
                              defaultValue={""}
                            >
                              <option disabled value="">
                                Select BlockChain Network
                              </option>
                              <option value="Ethereum">Ethereum</option>
                              <option value="Sepolia-Ethereum">
                                Sepolia Ethereum
                              </option>
                              <option value="Polygon">Polygon</option>
                              <option value="Base-Mainnet">Base Mainnet</option>
                            </select>
                          </div>
                        </div>
                      </label>
                    </fieldset>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "15%",
                    }}
                  ></div>
                </div>
                <div
                  style={{
                    marginBottom: "12px",
                    gap: "2%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <fieldset className="login-form input-fullwidth">
                    <label
                      htmlFor="tokenStandard"
                      id="tokenStandardLabel"
                      className="login-form-label"
                    >
                      Select Token Standard
                      <div className="input-div-css-1 input-div-css-2 input-fullwidth">
                        <div className="input-div-css-3">
                          <select
                            required
                            className="input-custom-css select-input"
                            id="tokenStandard"
                            aria-labelledby="tokenStandardLabel"
                            name="tokenStandard"
                            onChange={(e) => handleTokenGatingInfo(index, e)}
                            value={element.tokenStandard}
                            aria-invalid="false"
                            defaultValue={""}
                          >
                            <option disabled value="">
                              Select Token Standard
                            </option>
                            <option value="ERC721">ERC-721</option>
                            <option value="ERC1155">ERC-1155</option>
                          </select>
                        </div>
                      </div>
                    </label>
                  </fieldset>

                  <fieldset className="login-form input-fullwidth">
                    <label
                      htmlFor="contractAddress"
                      id="contractAddressLabel"
                      className="login-form-label"
                    >
                      Contract Address
                      <div className="input-div-css-1 input-fullwidth input-div-css-2">
                        <div className="input-div-css-3">
                          <input
                            required
                            name="contractAddress"
                            aria-labelledby="contractAddressLabel"
                            type="text"
                            className="input-custom-css input-custom-height"
                            id="contractAddress"
                            aria-invalid="false"
                            value={element.contractAddress}
                            onChange={(e) => handleTokenGatingInfo(index, e)}
                          ></input>
                        </div>
                      </div>
                    </label>
                  </fieldset>
                </div>

                <div
                  style={{
                    gap: "2%",
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  {element.tokenStandard === "ERC721" && (
                    <fieldset
                      style={{
                        width: element.tokenGatingType ? "100%" : "49%",
                      }}
                      className="login-form"
                    >
                      <label
                        htmlFor="tokenGatingType"
                        id="tokenGatingTypeLabel"
                        className="login-form-label"
                      >
                        Select Token Gating Type
                        <div className="input-div-css-1 input-div-css-2 input-fullwidth">
                          <div className="input-div-css-3">
                            <select
                              required
                              className="input-custom-css select-input"
                              id="tokenGatingType"
                              aria-labelledby="tokenGatingTypeLabel"
                              name="tokenGatingType"
                              onChange={(e) => handleTokenGatingInfo(index, e)}
                              value={element.tokenGatingType}
                              aria-invalid="false"
                              defaultValue={""}
                            >
                              <option disabled value="">
                                Select Token Gating Type
                              </option>
                              <option value="tokenId">
                                On the basis of Token ID
                              </option>
                              <option value="numberOfNFT">
                                On the basis of number of NFT
                              </option>
                            </select>
                          </div>
                        </div>
                      </label>
                    </fieldset>
                  )}
                  {(element.tokenStandard === "ERC1155" ||
                    (element.tokenStandard === "ERC721" &&
                      element.tokenGatingType === "tokenId")) && (
                    <fieldset className="login-form input-fullwidth">
                      <label
                        htmlFor="tokenId"
                        id="tokenIdLabel"
                        className="login-form-label"
                      >
                        Token ID
                        <div className="input-div-css-1 input-fullwidth input-div-css-2">
                          <div className="input-div-css-3">
                            <input
                              required
                              name="tokenId"
                              aria-labelledby="tokenIdLabel"
                              type="text"
                              className="input-custom-css input-custom-height"
                              id="tokenId"
                              aria-invalid="false"
                              value={element.tokenId}
                              onChange={(e) => handleTokenGatingInfo(index, e)}
                            ></input>
                          </div>
                        </div>
                      </label>
                    </fieldset>
                  )}
                  {(element.tokenStandard === "ERC1155" ||
                    (element.tokenStandard === "ERC721" &&
                      element.tokenGatingType === "numberOfNFT")) && (
                    <fieldset className="login-form input-fullwidth">
                      <label
                        htmlFor="nftRequired"
                        id="nftRequiredLabel"
                        className="login-form-label"
                      >
                        Minimum NFT Required
                        <div className="input-div-css-1 input-fullwidth input-div-css-2">
                          <div className="input-div-css-3">
                            <input
                              required
                              name="nftRequired"
                              aria-labelledby="nftRequiredLabel"
                              type="number"
                              className="input-custom-css input-custom-height"
                              id="nftRequired"
                              aria-invalid="false"
                              min="1"
                              value={element.nftRequired}
                              onChange={(e) => handleTokenGatingInfo(index, e)}
                            ></input>
                          </div>
                        </div>
                      </label>
                    </fieldset>
                  )}
                </div>
              </div>
              {index !== tokenGatingInfo.length - 1 && (
                <hr
                  style={{
                    color: "#2e7c67",
                    marginTop: "20px",
                    marginBottom: "20px",
                    width: "111%",
                  }}
                />
              )}
            </div>
          ))}
          <div
            style={{
              marginTop: "22px",
              display: "flex",
            }}
          >
            <div style={{ marginRight: "auto" }}></div>
            <div style={{ display: "flex" }}>
              <Button
                className="custom-color-button"
                variant="contained"
                onClick={handleRefresh}
                disabled={edit}
                sx={{ fontSize: "15px" }}
              >
                Reset
              </Button>

              <Button
                className="custom-color-button"
                sx={{
                  marginLeft: "6%",
                  fontSize: "15px",
                }}
                type="submit"
                variant="contained"
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </Box>
    </Box>
  );
}

export default CircleForm;
